export default "__VITE_ASSET__8petUYPE__"